
import { User } from '../types';
import { apiClient, isCloud, getCurrentUser } from '../lib/apiClient';

export { getCurrentUser as getUser } from '../lib/apiClient';

const saveUserLocal = (user: User) => {
  localStorage.setItem('user', JSON.stringify(user));
};

export const saveUser = async (user: User) => {
  saveUserLocal(user);
  if (isCloud && user.id) {
    try {
      await apiClient('/user', {
        method: 'PUT',
        body: JSON.stringify(user)
      });
    } catch (e) { console.error("Cloud save failed", e); }
  }
};

export const loginUser = async (username: string, password: string): Promise<{success: boolean, message?: string, user?: User}> => {
  if (isCloud) {
    try {
      const data = await apiClient('/auth/login', {
        method: 'POST',
        skipAuth: true,
        body: JSON.stringify({ username, password })
      });
      if (data.success) {
        saveUserLocal(data.user);
        return { success: true, user: data.user };
      }
      return { success: false, message: data.message };
    } catch (e: any) { return { success: false, message: e.message }; }
  } else {
    // Local Mock
    const u = getCurrentUser();
    if (u && u.username === username && u.password === password) return { success: true, user: u };
    return { success: false, message: '本地模式仅支持当前缓存用户' };
  }
};

export const registerUser = async (username: string, password: string, nickname: string): Promise<{success: boolean, message?: string, user?: User}> => {
  const newUser: User = {
    id: Date.now().toString(),
    username,
    password,
    nickname,
    avatar: `https://api.dicebear.com/9.x/avataaars/svg?seed=${username}`,
    externalToken: crypto.randomUUID()
  };
  
  if (isCloud) {
    try {
      const data = await apiClient('/auth/register', {
        method: 'POST',
        skipAuth: true,
        body: JSON.stringify(newUser)
      });
      if (data.success) {
        saveUserLocal(data.user);
        return { success: true, user: data.user };
      }
      return { success: false, message: data.message };
    } catch (e: any) { return { success: false, message: e.message }; }
  } else {
    saveUserLocal(newUser);
    return { success: true, user: newUser };
  }
};

export const logoutUser = () => {
  localStorage.removeItem('user');
};
